import { useState } from 'react';

import { ShareIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { useSearchStore } from '@/store/SearchStore';

export const ShareDirections = ({ className, children }: { className?: string; children?: React.ReactNode }) => {
  const { locationStart, locationEnd } = useSearchStore();
  const [copied, setCopied] = useState(false);

  const handleCopyLink = () => {
    const currentUrl = window.location.href;
    navigator.clipboard.writeText(currentUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Dialog>
      <DialogTrigger asChild className="print:hidden">
        {children ?? (
          <Button variant="outline" className={className}>
            <ShareIcon />
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Share directions</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-1 text-lg">
            <div className="flex gap-2">
              <div className="font-light">From</div>
              <div className="font-medium text-balance">{locationStart?.displayName}</div>
            </div>
            <div className="flex gap-2">
              <div className="font-light">To</div>
              <div className="font-medium text-balance">{locationEnd?.displayName}</div>
            </div>
          </div>

          <a
            href={window.location.href}
            className="break-all text-[var(--blue-one)] underline underline-offset-4"
            target="_blank"
            rel="noopener noreferrer"
          >
            {window.location.href}
          </a>

          <Button className="w-full" onClick={handleCopyLink}>
            {copied ? 'Copied!' : 'Copy link'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
